import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import TemplatesList from './TemplatesList';
import EditSavedFilter from './EditSavedFilter';

interface ManageTemplateDialogProps {
    open: boolean;
    handleClose: () => void;
    area: string;
}

const ManageTemplateDialog: React.FC<ManageTemplateDialogProps> = ({
    open,
    handleClose,
    area,
}) => {
    const [editTemplate, setEditTemplate] = React.useState<any>(null);

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            key={'save_template_dialog'}
            maxWidth={editTemplate ? 'lg' : 'md'}
            fullWidth
        >
            {editTemplate ? (
                <EditSavedFilter
                    area={area}
                    setEditTemplate={setEditTemplate}
                    editTemplate={editTemplate}
                    handleClose={handleClose}
                />
            ) : (
                <TemplatesList
                    handleClose={handleClose}
                    setEditTemplate={setEditTemplate}
                    area={area}
                />
            )}
        </Dialog>
    );
};

export default ManageTemplateDialog;
